import schema from './schema'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {
    weekday_preferences_by_timeslot_collection_id_sorted: ( $models, $registry, $store ) => {

      if ( !( 'timeslotCollectionId' in $store.definedProps ) ) {
        throw new Error('Please define timeslotCollectionId in "with".')
      }

      let timeslotCollectionId = $store.definedProps[ 'timeslotCollectionId' ]

      return this.$models.timeslotWeekdayPref
        .with({ timeslotCollectionId })
        .getList()
        .itemsAsArray()
    },
  },
  staticActions: {},
  schema:  schema
};
